import { createAction } from '@reduxjs/toolkit';
import EcomEngineAPI from 'api/ecom_engine_api';
import { setFerryGrouping } from 'redux/actions/ui/sealink';

export const replaceBooking = createAction('resources/replaceBooking');

export const discardBooking =
  ({ clearFerryGrouping = false, clearBooking = true } = {}) =>
  (dispatch) =>
    EcomEngineAPI.booking
      .discard()
      .then(() => {
        if (clearBooking) {
          dispatch(replaceBooking({}));
        }
      })
      .then(() => {
        if (clearFerryGrouping === true) {
          dispatch(setFerryGrouping([]));
        }
      });
